import { END } from 'redux-saga'
import {race, delay, fork, call, put, take, select, takeEvery, takeLatest, all} from 'redux-saga/effects';
import {captureFromCamera} from '../../Components/CapturePhotoDialog/useCapturePhoto'
import {keyStrokePlay, themeStart, themeStop} from '../../Helpers/sound'
import {
  createVadChannel,
  makeTranscriptionForm,
  __private as sttPrivate, getArnoldWakeMatch, stripWakeNamePunctuation,
} from '../../Helpers/stt'
import apiServer from '../../Api/Backend'
import {startTTSEngine} from '../../Helpers/tts'
import {getMoodFromText} from '../../Helpers/emojis'
import {IS_MOBILE_DEVICE, isMacOS} from '../../Helpers/utils'
import {
  audioStart,
  audioStop,
  audioSpeechSegmentReady,
  audioTranscribeRequest,
  audioTranscribeResult,
  audioError,
  audioSetEnabled,
  audioSetVadEnabled,
  audioSetSttEnabled,
  audioSetHearing,
  userSaidAction,
  audioSetRobotSpeaking,
  audioSetTtsHealth,
  audioSetTtsWord, setHighlightRange, audioSomeNoise, predict, audioSetAwaitingSttFollowup, audioFollowupSpeechStarted,
} from '../actions'
import {
  AUDIO_FOLLOWUP_SPEECH_STARTED,
  AUDIO_REDUCER,
  AUDIO_SET_AWAITING_STT_FOLLOWUP,
  AUDIO_SET_TTS_MOOD, AUDIO_STT_MAX_AUDIO_LENGTH,
  AWAITING_STT_FOLLOWUP,
  ENABLE_IMAGE_ON_STT_AND_MANUAL,
  ENABLED,
  GENERAL_REDUCER,
  HIGHLIGHT_RANGE,
  INITIATOR_STT,
  NETWORK_SPEED,
  ROBOT_SPEAKING,
  SET_HIGHLIGHT_RANGE, SOLE_BOT_NAME_FOLLOWUP_TRANSCRIPT_FAILSAFE_MS, SOLE_BOT_NAME_FOLLOWUP_WINDOW_MS,
  STT_ENABLED,
  TIME_TO_HIDE_HIGHLIGHT_AFTER_TTS_WORD_MS,
  UPLOAD_MBPS,
  VAD_ENABLED
} from '../consts'
import {
  ON_APP_LOAD, PLAY_KEYSTROKE, REFLECTED_CHAT,
  TIME_TO_INIT_THEME_AFTER_KEYSTROKE,
} from '../general/consts'
import {store} from '../store'
import {
  AUDIO_START,
  AUDIO_STOP,
  AUDIO_SPEECH_SEGMENT_READY,
  AUDIO_SET_ROBOT_SPEAKING, USER_SAID, TTS_SPEAK_TOKEN, AUDIO_SET_TTS_WORD,
} from './consts'
import {
  VIDEO_REDUCER
} from '../consts'
import {
  IS_CAMERA_ENABLED, UPLOAD_SPEED_THRESHOLD_FOR_CAMERA,
} from '../video/consts'
import {setCapturedImage} from '../video/actions'

let tts = null


function* userSaidSaga({ rawText }) {
  try {
    const text = rawText
      ?.trim()
      .replace(/^['"]+|['"]+$/g, '')

    if (!text) return

    const botName = yield select(state => state.getIn(['general','botName']))
    const awaitingFollowup = yield select(state => state.getIn([AUDIO_REDUCER, AWAITING_STT_FOLLOWUP]))

    if (botName === 'Arnold') {
      const match = getArnoldWakeMatch(text)

      if (match) {
        const slicedText = text.slice(match.index)
          .trim()
          .replace(/^['"]+|['"]+$/g, '')

        const contentAfterWakeName = stripWakeNamePunctuation(
          slicedText.slice(match.target.length)
        )

        if (!contentAfterWakeName) {
          console.log('gpt0604', 'sole bot name detected; opening STT followup window', slicedText)
          yield put(audioSetAwaitingSttFollowup(true))
          return
        }

        yield put(audioSetAwaitingSttFollowup(false))

        console.log('SAGA: user said', slicedText)

        const cameraEnabled = yield select(state => state.getIn([VIDEO_REDUCER, IS_CAMERA_ENABLED]))
        const uploadMbps = yield select(state => state.getIn([GENERAL_REDUCER,NETWORK_SPEED,UPLOAD_MBPS]))

        let image
        if (uploadMbps > UPLOAD_SPEED_THRESHOLD_FOR_CAMERA && cameraEnabled && ENABLE_IMAGE_ON_STT_AND_MANUAL) {
          image = yield call(captureFromCamera)
          yield put(setCapturedImage(image))
        }
        if (!image) {
          yield put(predict({prompt:slicedText.trim(),initiator:INITIATOR_STT}))
        } else {
          const prompt = {
            content: slicedText.trim(),
            extra: [{type: 'imageFile', base64Url: image}]
          }
          yield put(predict({prompt,initiator:INITIATOR_STT}))
        }
        return
      }

      if (awaitingFollowup) {
        yield put(audioSetAwaitingSttFollowup(false))
        console.log('gpt0604', 'accepting STT followup without bot name', text)

        const cameraEnabled = yield select(state => state.getIn([VIDEO_REDUCER, IS_CAMERA_ENABLED]))
        const uploadMbps = yield select(state => state.getIn([GENERAL_REDUCER,NETWORK_SPEED,UPLOAD_MBPS]))

        let image
        if (uploadMbps > UPLOAD_SPEED_THRESHOLD_FOR_CAMERA && cameraEnabled && ENABLE_IMAGE_ON_STT_AND_MANUAL) {
          image = yield call(captureFromCamera)
          yield put(setCapturedImage(image))
        }
        if (!image) {
          yield put(predict({prompt:text.trim(),initiator:INITIATOR_STT}))
        } else {
          const prompt = {
            content: text.trim(),
            extra: [{type: 'imageFile', base64Url: image}]
          }
          yield put(predict({prompt,initiator:INITIATOR_STT}))
        }
        return
      }

      console.log(`userSaidSaga: text "${text.toUpperCase()}" does not include Arnold, ignoring`)
    } else {
      // purely theoretical case where botName is not Arnold
      console.log('SAGA: user said to a non-Arnold bot', text)
      yield put(predict({prompt:text,initiator:INITIATOR_STT}))
    }
  } catch (e) {
    console.log('error in userSaidSaga', { e })
  }
}
const STT_AUDIO_DEBUG = false

function* audioSTTControllerSaga() {

  const log = (...args) => {
    if (!STT_AUDIO_DEBUG) return
    console.log(`[STT_AUDIO][${new Date().toISOString()}]`, ...args)
  }

  while (true) {
    yield take(AUDIO_START)
    const enabled = yield select((s) => s.getIn([AUDIO_REDUCER, ENABLED]))
    const vadEnabled = yield select((s) => s.getIn([AUDIO_REDUCER, VAD_ENABLED]))
    if (!enabled || !vadEnabled) {
      yield put(audioStop())
      yield put(audioSetHearing('silence'))
      continue
    }

    log('SttAudioSaga - Creating VAD channel...')
    const chan = yield call(createVadChannel, { debug: STT_AUDIO_DEBUG })
    log('SttAudioSaga - returned from VAD channel creation (might as well continue creation in background)')

    // Hearing detector state (EMA)
    let ema = 0
    let frameCount = 0
    const EMA_ALPHA = 0.15
    const SHAKY_THRESHOLD = 0.06
    const SILENCE_THRESHOLD = 0.03
    let hearing = 'silence'

    const resetHearing = function* () {
      ema = 0
      frameCount = 0
      if (hearing !== 'silence') {
        hearing = 'silence'
        yield put(audioSetHearing('silence'))
      } else {
        // still force UI sane if you prefer:
        yield put(audioSetHearing('silence'))
      }
    }

    const updateHearingFromProb = function* (p) {
      if (typeof p !== 'number') return
      ema = EMA_ALPHA * p + (1 - EMA_ALPHA) * ema
      frameCount += 1

      if (frameCount % 10 !== 0) return

      if (hearing === 'silence' && ema >= SHAKY_THRESHOLD) {
        hearing = 'shaky'
        yield put(audioSetHearing('shaky'))
      } else if (hearing === 'shaky' && ema <= SILENCE_THRESHOLD) {
        hearing = 'silence'
        yield put(audioSetHearing('silence'))
      }
    }

    let frameSeen = 0
    let frameUsed = 0
    let lastFrameLog = Date.now()

    try {
      while (true) {
        const enabledNow = yield select((s) => s.getIn([AUDIO_REDUCER, ENABLED]))
        const vadEnabledNow = yield select((s) => s.getIn([AUDIO_REDUCER, VAD_ENABLED]))
        if (!enabledNow || !vadEnabledNow) break

        const robotSpeakingNow = yield select((s) => s.getIn([AUDIO_REDUCER, ROBOT_SPEAKING]))
        if (robotSpeakingNow) {
          // IMPORTANT: do not stop/close VAD; just keep UI state sane and drain events.
          yield* resetHearing()
        }

        const { evt, stopped } = yield race({
          evt: take(chan),
          stopped: take(AUDIO_STOP),
        })

        if (stopped) break
        if (evt === END) {
          log('channel END received')
          break
        }
        if (!evt) continue


        if (evt.type === 'error') {
          yield put(audioError(evt.error))
          break
        }

        // Gate: robot speaking => ignore all VAD events (but we ARE draining the channel).
        if (robotSpeakingNow) {
          continue
        }

        if (evt.type === 'frame') {
          const pSpeech =
            typeof evt?.probabilities?.speech === 'number'
              ? evt.probabilities.speech
              : typeof evt?.probabilities?.isSpeech === 'number'
                ? evt.probabilities.isSpeech
                : null

          yield* updateHearingFromProb(pSpeech)
          continue
        }

        if (evt.type !== 'speechStart') {
          continue
        }
        // segment mode
        let chunks = []
        const segmentStartedAt = Date.now()
        log('speechStart -> segment mode')
        const awaitingFollowupAtSpeechStart = yield select((s) =>
          s.getIn([AUDIO_REDUCER, AWAITING_STT_FOLLOWUP])
        )
        if (awaitingFollowupAtSpeechStart) {
          // gpt0604: once the user starts answering after the wake name, do not close the 10s window mid-sentence
          yield put(audioFollowupSpeechStarted())
        }

        while (true) {
          const { nextEvt, timedOut, stopped2 } = yield race({
            nextEvt: take(chan),
            timedOut: delay(AUDIO_STT_MAX_AUDIO_LENGTH),
            stopped2: take(AUDIO_STOP),
          })
          if (stopped2) return
          if (nextEvt === END) {
            log('VAD channel END received (segment)')
            return
          }
          if (!nextEvt && !timedOut) continue

          const enabledSeg = yield select((s) => s.getIn([AUDIO_REDUCER, ENABLED]))
          const vadEnabledSeg = yield select((s) => s.getIn([AUDIO_REDUCER, VAD_ENABLED]))
          if (!enabledSeg || !vadEnabledSeg) return

          const robotSpeakingSeg = yield select((s) => s.getIn([AUDIO_REDUCER, ROBOT_SPEAKING]))
          if (robotSpeakingSeg) {
            // Robot started talking mid-segment -> discard segment.
            yield* resetHearing()
            log('robotSpeaking=true mid-segment -> discard segment')
            break
          }

          if (timedOut) {
            const floatAudio =
              chunks.length > 0 ? sttPrivate.concatFloat32Chunks(chunks) : new Float32Array(0)
            log('segment timeout -> dispatch segment', {
              ms: Date.now() - segmentStartedAt,
              samples: floatAudio.length,
            })
            yield put(audioSpeechSegmentReady(floatAudio))
            break
          }

          if (nextEvt.type === 'error') {
            yield put(audioError(nextEvt.error))
            return
          }

          if (nextEvt.type === 'frame') {
            frameSeen++

            if (Date.now() - lastFrameLog > 10000) {
              log('frames seen (10s)', frameSeen, 'used', frameUsed)
              frameSeen = 0
              frameUsed = 0
              lastFrameLog = Date.now()
            }

            chunks.push(nextEvt.frame)
            frameUsed++

            const pSpeech =
              typeof nextEvt?.probabilities?.speech === 'number'
                ? nextEvt.probabilities.speech
                : typeof nextEvt?.probabilities?.isSpeech === 'number'
                  ? nextEvt.probabilities.isSpeech
                  : null

            yield put(audioSomeNoise({pSpeech}))

            yield* updateHearingFromProb(pSpeech)
            continue
          }

          if (nextEvt.type === 'speechEnd') {
            const floatAudio =
              nextEvt.floatAudio ||
              (chunks.length > 0 ? sttPrivate.concatFloat32Chunks(chunks) : new Float32Array(0))

            log('speechEnd -> dispatch segment', {
              ms: Date.now() - segmentStartedAt,
              samples: floatAudio.length,
            })

            yield put(audioSpeechSegmentReady(floatAudio))
            break
          }
        }

        log('leaving segment mode')
      }
    } finally {
      log('controller saga finally: closing channel')
      try {
        chan.close()
      } catch (e) {
        log('channel close error', e)
      }
      yield put(audioStop())
      yield put(audioSetHearing('silence'))
    }
  }
}


function* transcribeSegmentSaga({ floatAudio }) {
  try {
    const robotSpeaking = yield select((s) => s.getIn([AUDIO_REDUCER, ROBOT_SPEAKING])) // NEW
    if (robotSpeaking) return // NEW

    const enabled = yield select((s) => s.getIn([AUDIO_REDUCER, ENABLED]))
    const sttEnabled = yield select((s) => s.getIn([AUDIO_REDUCER, STT_ENABLED]))
    if (!enabled || !sttEnabled) {
      return
    }

    yield put(audioTranscribeRequest())

    const form = makeTranscriptionForm(floatAudio)
    const transcriptObj = yield call(apiServer.postWithFetch, '/audioTranscribe', form)
    yield put(audioTranscribeResult(transcriptObj))

    const { isOk, text, message } = transcriptObj || {}
    if (!isOk) {
      if (STT_AUDIO_DEBUG) console.warn('Audio transcription failed:', message)
      return
    }

    let transcript = text || ''

    // Feed into your existing pipeline:
    yield put(userSaidAction(transcript))
  } catch (e) {
    yield put(audioError(e))
  }
}

function* robotSpeakingGateSaga() {
  while (true) {
    const action = yield take(AUDIO_SET_ROBOT_SPEAKING)
    const speaking = !!action.speaking

    // Do NOT stop audio / VAD here.
    if (speaking) {
      yield put(audioSetHearing('silence'))
    }
  }
}

let initThemeTimer = null
let hasWarnedAboutMacOSTheme = false
let hasWarnedAboutCalendarTheme = false
// if it happens that I hear a double theme, it may be related to webpack-hot-refresh
// that messes the timers.  the test is only in light of no webpack-hot-refresh
const triggerThemeTimeout = async () => {
  if (isMacOS()) {
    if (!hasWarnedAboutMacOSTheme) {
      hasWarnedAboutMacOSTheme = true
      console.warn('not playing theme on macOS')
    }
    return
  }
  const now = new Date();
  const themeAllowedAfter = new Date('2027-02-01T00:00:00');
  if (now < themeAllowedAfter) {
    if (!hasWarnedAboutCalendarTheme) {
      hasWarnedAboutCalendarTheme = true
      console.warn('not playing theme before 1-Feb-27')
      // one reason I don't erase the theme music code altogether: the only reason
      // to disable music theme is after proving AuPred is a desirable feature
    }
    return
  }
  clearTimeout(initThemeTimer)
  initThemeTimer = setTimeout(async () => {
    await themeStart(IS_MOBILE_DEVICE)
    await triggerThemeTimeout()  // play theme again after it ends and some time passed
  }, TIME_TO_INIT_THEME_AFTER_KEYSTROKE)
}

function* playKeystrokeSaga({isHumanKey = false}) {
  try {
    yield call(themeStop)
    yield call(triggerThemeTimeout)
    if (!isHumanKey) {
      if (typeof tts === 'undefined')
        keyStrokePlay(IS_MOBILE_DEVICE)
    }
  } catch (e) {
    console.log('error in playKeystrokeSaga', {e})
  }
}


function* onAppLoadAudioSaga() {
  yield call(triggerThemeTimeout)
  yield put(audioStart())

  // Drop out-of-order word events here (monotonic eventSeq from tts.js),
  // and do not key anything on server job IDs (GUIDs).
  let lastEventSeq = 0

  tts = yield call(startTTSEngine, {
    rate: 1,
    idleFlushMs: 220,
    maxChunkChars: 140,
    onRobotSpeakingChange: (speaking) => store.dispatch(audioSetRobotSpeaking(!!speaking)),
    onTtsHealthChange: (health) => store.dispatch(audioSetTtsHealth(health)),
    onRobotWordChange: (info) => {
      try {
        const word = info?.word

        if (!word) return

        const seq = typeof info?.eventSeq === 'number' ? info.eventSeq : 0
        if (seq && seq <= lastEventSeq) return
        if (seq) lastEventSeq = seq

        store.dispatch(audioSetTtsWord({
          word,
        }))
      } catch (e) {
        console.warn('onRobotWordChange dispatch failed', e)
      }
    },
  })

  if (tts) {
    console.log('tts engine connected')
  }
}

function* acceptSpeakableTokensSaga() {
  while (true) {
    const action = yield take(TTS_SPEAK_TOKEN)
    const {token, shouldFlush} = action
    if (tts && token) {
      yield call(tts.pushToken, token)
    }
    if (shouldFlush) {
      yield call(tts.flush)
      console.log('gizim', 1221649, 'flushed TTS engine');
    }
  }
}
function* audioSetTTSWordSaga({payload}) {
  try {
    const {word} = payload

    const _highlightRange = yield select(state => state.getIn([AUDIO_REDUCER, HIGHLIGHT_RANGE]))
    let highlightRange = _highlightRange?.toJS()

    const reflectedChat = yield select(state => state.getIn([GENERAL_REDUCER, REFLECTED_CHAT]))

    for (let i = reflectedChat.size-1; i >=0 && i>=reflectedChat.size-2; i--) { // always take last 2 chunks (typically user + assistant [which we require])
      const reflectedChatEntry = reflectedChat.get(i)
      if (reflectedChatEntry.get('role') === 'assistant') {
        const text = reflectedChatEntry.get('text') || ''
        const index = text.indexOf(word, highlightRange.end)
        console.log('gizim', 691190, 'word', word);

        // sometimes lose emoji, probably in the ending
        const mood = getMoodFromText(word)

        if (index !== -1) {
          yield put(setHighlightRange(index, index + word.length))
          if (mood) {
            yield put({type: AUDIO_SET_TTS_MOOD, mood})
          }
          break
        } else {
          const indexFromStart = text.indexOf(word)
          if (indexFromStart !== -1) {
            yield put(setHighlightRange(indexFromStart, indexFromStart + word.length))
            if (mood) {
              yield put({type: AUDIO_SET_TTS_MOOD, mood})
            }
            break
          }
        }
      }
    }
  } catch (e) {
    console.log('error in audioSetTtsWordSaga', {e})
  }
}


export function* watchHighlightTimeoutSaga() {
  while (true) {
    const { timeout, action } = yield race({
      timeout: delay(TIME_TO_HIDE_HIGHLIGHT_AFTER_TTS_WORD_MS),
      action: take(SET_HIGHLIGHT_RANGE),
    })

    if (timeout) {
      const current = yield select(state =>
        state.getIn([AUDIO_REDUCER, HIGHLIGHT_RANGE])?.toJS()
      )

      if (current?.start === -1 && current?.end === -1) {
        continue
      }
      yield put(setHighlightRange(-1, -1))
      yield call(tts.flush)
      console.log('gizim', 9169148, 'tts flushing after removing highlight');

    }
  }
}

function* sttFollowupWindowSaga() {
  while (true) {
    yield take(action =>
      action.type === AUDIO_SET_AWAITING_STT_FOLLOWUP && action.awaiting
    )

    const { timeout, speechStarted, cleared } = yield race({
      timeout: delay(SOLE_BOT_NAME_FOLLOWUP_WINDOW_MS),
      speechStarted: take(AUDIO_FOLLOWUP_SPEECH_STARTED),
      cleared: take(action =>
        action.type === AUDIO_SET_AWAITING_STT_FOLLOWUP && !action.awaiting
      ),
    })

    if (cleared) {
      continue
    }

    if (timeout) {
      console.log('gpt0604', 'STT followup window expired without speech')
      yield put(audioSetAwaitingSttFollowup(false))
      continue
    }

    if (speechStarted) {
      const { clearedAfterSpeech, failSafe } = yield race({
        clearedAfterSpeech: take(action =>
          action.type === AUDIO_SET_AWAITING_STT_FOLLOWUP && !action.awaiting
        ),
        failSafe: delay(SOLE_BOT_NAME_FOLLOWUP_TRANSCRIPT_FAILSAFE_MS),
      })

      if (failSafe && !clearedAfterSpeech) {
        console.log('gpt0604', 'STT followup window failsafe expired after speech start')
        yield put(audioSetAwaitingSttFollowup(false))
      }
    }
  }
}

function* watchVariousSagas() {
  yield takeEvery(ON_APP_LOAD, onAppLoadAudioSaga)
  yield takeLatest(USER_SAID, userSaidSaga)
  yield takeEvery(PLAY_KEYSTROKE, playKeystrokeSaga)
  yield takeEvery(AUDIO_SPEECH_SEGMENT_READY, transcribeSegmentSaga)
  yield takeEvery(AUDIO_SET_TTS_WORD,audioSetTTSWordSaga)
  yield fork(robotSpeakingGateSaga)
  yield fork(audioSTTControllerSaga)
  yield fork(acceptSpeakableTokensSaga)
  yield fork(watchHighlightTimeoutSaga)
  yield fork(sttFollowupWindowSaga)
}

export default function* rootSaga() {
  yield all([watchVariousSagas()])
}
